import React from 'react';
import { Section } from './ui/Section';
import { smoothScrollToElement } from '../utils/scrollHelpers';
export function InstructorTestimonials() {
  const testimonials = [{
    quote: 'Compré domingo, lunes tuve mi primera consulta con todo estructurado. El paciente lo notó.',
    author: 'Laura M.',
    location: 'Madrid'
  }, {
    quote: 'El Pack Legal me quitó un peso enorme. Ahora es parte natural del proceso.',
    author: 'Carlos F.',
    location: 'Barcelona'
  }, {
    quote: 'Los guiones me cambiaron la vida. Respondo en 10 segundos con total seguridad.',
    author: 'Ana S.',
    location: 'Valencia'
  }, {
    quote: 'En 3 semanas conseguí mis primeros 4 pacientes sin pagar publicidad.',
    author: 'Miguel T.',
    location: 'Sevilla'
  }];
  const scrollToPricing = () => {
    smoothScrollToElement('pricing');
  };
  return <Section data-id="element-136">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-2 text-brand-primary" data-id="element-137">
        ⭐ +500 PSICÓLOGOS LO USAN
      </h2>
      <p className="font-body text-center text-brand-accent font-semibold mb-6" data-id="element-138">
        4.9/5 estrellas
      </p>

      <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto mb-6" data-id="element-139">
        {testimonials.map((testimonial, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-4 shadow-sm" data-id="element-140">
            <div className="flex text-brand-accent text-xs mb-2" data-id="element-141">
              ⭐⭐⭐⭐⭐
            </div>
            <p className="font-body text-brand-text text-sm mb-3 italic" data-id="element-142">
              "{testimonial.quote}"
            </p>
            <p className="font-body text-brand-textMuted text-xs" data-id="element-143">
              <strong data-id="element-144">{testimonial.author}</strong> · {testimonial.location}
            </p>
          </div>)}
      </div>

      <div className="text-center" data-id="element-145">
        <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-primary font-body font-bold text-lg py-3 px-8 rounded-lg transition-all hover:shadow-gold" data-id="element-146">
          🚀 QUIERO EL SISTEMA AHORA
        </button>
      </div>
    </Section>;
}